import app, { Component } from 'apprun';
import { serializeObject, companies, locations } from './api';
export default class SearchAdvComponent extends Component {
  state = { brokerageOptions: [], locationOptions: [] };

  view = (state) => {
    if (!state) {return;}
    return (
      <div>
        <form id="searchAdvForm" onkeyup={e => this.run('keyup', e)}>
          <div class="list-group">
            <div class="list-group-item">
              User Name: <input id="userName" name="userName" class="pull-right" data-validate />
              <div id="userNameErrMsg" class="text-danger"></div>
            </div>
            <div class="list-group-item">
              First Name: <input id="firstName" name="firstName" class="pull-right" data-validate />
              <div id="firstNameErrMsg" class="text-danger"></div>
            </div>
            <div class="list-group-item">
              Last Name: <input id="lastName" name="lastName" class="pull-right" data-validate />
              <div id="lastNameErrMsg" class="text-danger"></div>
            </div>
            <div class="list-group-item">
              Company: &nbsp;
              <select
                id="companyID"
                name="companyID"
                oninput={e => this.run('companySelectionChanged', e.target.value)}
                data-validate>
                <option value="0">[Select]</option>
                {state.brokerageOptions.map(r => (
                  <option value={r.id} selected={r.id === state.companyId ? 'selected' : null}>
                    {r.id + ' - ' + r.name}
                  </option>
                ))}
              </select>
              <div id="companyIDErrMsg" class="text-danger" />
            </div>
            <div class="list-group-item">
              Location: &nbsp;&nbsp;
              <select id="locationID" name="locationID" data-validate>
                <option value="0">[Select]</option>
                {state.locationOptions.map(r => (
                  <option value={r.id} selected={r.id === state.locationId ? 'selected' : null}>
                    {r.id + ' - ' + r.name}
                  </option>
                ))}
              </select>
              <div id="locationIDErrMsg" class="text-danger" />
            </div>
            <div class="list-group-item">
              Max Results: &nbsp;
              <select id="maxResults" name="maxResults" data-validate>
                {[100, 1000, 10000].map(r => (
                  <option value={r}>{r}</option>
                ))}
              </select>
              <div id="companyIDErrMsg" class="text-danger" />
            </div>
          </div>

          <div>
            Custom Search: <p></p>
            <textarea id="customFilter" name="customFilter" style={{ width: '100%' }} />
            <div id="customFilterErrMsg" class="text-danger"></div>
          </div>
        </form>
        <div>
          <div class="edit-buttons">
            <button class="btn btn-xs pull-right" onclick={() => this.run('reset')}>
              Reset
            </button>
            &nbsp;
            <button class="btn btn-primary btn-xs pull-right" onclick={() => this.run('search')}>
              Search
            </button>
          </div>
        </div>
        <div>
          Examples of Custom Search:<br/>
          Search for email: <b>&#123;emailaddress="*@johnston*"&#125;</b><br/>
          Search for personId: <b>&#123;PersonId &gt; 61000 &#125;</b><br/>
          Search Inactive with first name: <b>&#123;active=0, firstname="k*"&#125;</b><br/>
          Search last name and city: <b>&#123;lastname="ad*", city="Edmonton"&#125;</b><br/>
        </div>
      </div>
    );
  };

  update = {
    refresh: async (state, companyId, locationId) => {
      state.locationId = locationId ? locationId : 0;
      state.companyId = companyId ? companyId : 0;

      if (state.brokerageOptions.length === 0) {
        state.brokerageOptions = await companies.getAllCompanies();
      }
      this.run('companySelectionChanged', state.companyId);
      return state;
      //const a = serializeObject(document.getElementById('NewUserForm'));
    },

    companySelectionChanged: async (state, idx) => {
      state.companyId = idx;
      state.locationOptions =
        state.companyId === 0
          ? await locations.getAllLocations()
          : await locations.getLocationsByCompanyID(state.companyId);
      return state;
    },

    reset: (state) => {
      state.companyId = 0;
      state.locationId = 0;
      state.locationOptions = [];
      const nodesArray = [].slice.call(document.getElementById('searchAdvForm').querySelectorAll('input'));
      nodesArray.map(p => (p.value = ''));
      return state;
    },

    search: (state) => {
      const criteria = serializeObject(document.getElementById('searchAdvForm'));
      this.run('#get-AdvSearch-results', criteria);
      return state;
    },

    keyup: (state, e) => {
      if (e.keyCode === 13) {
        e.preventDefault();
        this.run('search', state);
      }
    }
  };

  mounted = ({ state }) => {
    this.run('refresh', state.companyId, state.locationId);
  };
}
